/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Vehicle_Gps_ResolveInputs */

const vi_vehicle_gps_resolve = /** @type {(inputs: Vehicle_Gps_ResolveInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Kiểm tra IMEI`)
};

/**

* @param {Vehicle_Gps_ResolveInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const vehicle_gps_resolve = /** @type {((inputs?: Vehicle_Gps_ResolveInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Vehicle_Gps_ResolveInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_vehicle_gps_resolve(inputs)
});